import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {

    create: async (email, password, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "researchers/signin";


        const body = JSON.stringify({
            researcher: {
                email,
                password
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    destroy: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "researchers/signout";

        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    researcherInfo: async (handleRedirect = null) => {
        // This doesn't use the api/v1 format. 
        const url = "/researchers/researcher_info";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })
            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    companyInfo: async (handleRedirect = null) => {
        // This doesn't use the api/v1 format. 
        const url = "/researchers/company_info";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })
            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


}